import React from 'react'
import injectStyles from 'react-jss'

import { Table } from 'Components/Table'
import { Th } from 'Components/Table/Th'
import { Tr } from 'Components/Table/Tr'

import Row from './Row'

import styles from './styles'

const InventoryMovementsView = ({
  movements,
  cityId,
  classes,
  tag,
  cityTimezone,
}) => {
  return (
    <Table className={classes.table}>
      <thead>
        <Tr>
          <Th>Date Time</Th>
          <Th>Quantity</Th>
          <Th>Tag</Th>
          <Th>Comments</Th>
          <Th>Related User</Th>
          <Th>Related Mission</Th>
          <Th>Related City</Th>
        </Tr>
      </thead>
      <tbody>
        {(movements || []).map((m, index) => (
          <Row
            key={index}
            {...m}
            cityId={cityId}
            tag={tag}
            classes={classes}
            cityTimezone={cityTimezone}
          />
        ))}
      </tbody>
    </Table>
  )
}

export default injectStyles(styles)(InventoryMovementsView)
